import { toast } from 'react-toastify';

export function showSavedToast(translate: (value: string) => string) {
    toast.info(translate('common.saved'), { autoClose: 3000, position: 'top-center' });
}
